import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "project-area" }
const _hoisted_2 = { class: "project-area__container" }
const _hoisted_3 = {
  class: "container-fluid pe-xl-0 overflow-hidden",
  ref: "container"
}
const _hoisted_4 = { class: "row gx-4 gx-xl-5 gy-0" }
const _hoisted_5 = { class: "col-12 pb-5 pb-xl-0 col-xl-5 col-xxl-4" }
const _hoisted_6 = { class: "col-12 col-xl-7 col-xxl-8 align-self-center" }
const _hoisted_7 = {
  class: "project-area__map",
  ref: "map"
}
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "subsidy" }, [
  /*#__PURE__*/_createElementVNode("iframe", { src: "https://cas.questionizer.eu/(S(1yu1iafwxnqpajwjjxnuexic))/Default.aspx?sid=a9c24b04-13e8-4eca-9301-4b018ec6bd40" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundPattern = _resolveComponent("BackgroundPattern")!
  const _component_TextSectionHeadline = _resolveComponent("TextSectionHeadline")!
  const _component_TextSectionContent = _resolveComponent("TextSectionContent")!
  const _component_PageIconCard = _resolveComponent("PageIconCard")!
  const _component_PageIconCardsGrid = _resolveComponent("PageIconCardsGrid")!
  const _component_SectionSpacerClouds = _resolveComponent("SectionSpacerClouds")!
  const _component_SectionSpacerBar = _resolveComponent("SectionSpacerBar")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_BackgroundPattern),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_TextSectionHeadline, {
              align: "center",
              class: "text-xl-start"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "headline")
              ]),
              _: 3
            }),
            _createVNode(_component_TextSectionContent, {
              align: "center",
              class: "text-xl-start"
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "content")
              ]),
              _: 3
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, null, 512)
          ])
        ])
      ], 512),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _createVNode(_component_TextSectionHeadline, null, {
            default: _withCtx(() => [
              _createTextVNode(" Unsere Themen der energetischen Sanierung ")
            ]),
            _: 1
          }),
          _createVNode(_component_PageIconCardsGrid, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "page-icon-cards", {}, () => [
                _createVNode(_component_PageIconCard, {
                  "page-type": "3",
                  url: "/waermeversorgung/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Wärmeversorgung ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_PageIconCard, {
                  "page-type": "1",
                  url: "/gebaeudehuelle/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Gebäudehülle ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_PageIconCard, {
                  "page-type": "2",
                  url: "/photovoltaik/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Photovoltaik ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_PageIconCard, {
                  "page-type": "4",
                  url: "/e-mobilitaet/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" E-Mobilität ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 3
          }),
          _createVNode(_component_TextSectionHeadline, null, {
            default: _withCtx(() => [
              _createTextVNode(" Förderauskunft ")
            ]),
            _: 1
          }),
          _hoisted_9
        ])
      ])
    ]),
    (_ctx.spacer === 'clouds')
      ? (_openBlock(), _createBlock(_component_SectionSpacerClouds, {
          key: 0,
          placement: _ctx.spacerCloudsPlacement
        }, null, 8, ["placement"]))
      : _createCommentVNode("", true),
    (_ctx.spacer === 'bar')
      ? (_openBlock(), _createBlock(_component_SectionSpacerBar, {
          key: 1,
          align: _ctx.spacerBarAlign
        }, null, 8, ["align"]))
      : _createCommentVNode("", true)
  ]))
}